import { Checkbox } from "antd";
import "./style.css";

const HexCheckbox = ({
  checkboxProps,
  className,
  value,
  subLabel,
  checkboxType,
}) => {
  const { id, mode, label, checked, onChange, customValue } = checkboxProps;
  const onGroupCheckboxChange = (checkedValues) => {
    onChange(checkedValues, id);
  };

  const onSingleCheckboxChange = ({ target }) => {
    if (mode === "single" && customValue) {
      checkboxProps.onChange(value, id);
    } else {
      checkboxProps.onChange(target.checked, id);
    }
  };

  const isChecked = () => {
    return mode === "single" ? checked : value;
  };

  if (checkboxType === "group") {
    return (
      <Checkbox.Group
        {...checkboxProps}
        className={`hex-checkbox ${className}`}
        onChange={onGroupCheckboxChange}
        id={label}
        value={value}
      />
    );
  } else
    return (
      <Checkbox
        className={`hex-checkbox ${className}`}
        onChange={onSingleCheckboxChange}
        checked={isChecked()}
        id={label || "checkbox"}
      >
        {label || null} {subLabel && <span>{subLabel}</span>}
      </Checkbox>
    );
};

export default HexCheckbox;
